import { render, staticRenderFns } from "./UcFooter.yaml?vue&type=template&id=c81a8d8c&component"
import script from "./UcFooter.yaml?vue&type=script&lang=ts&component"
export * from "./UcFooter.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports